import instance from "@/services/api";

export const contragentAVRApi = {
  async list(clientRequestId) {
    return await instance()
      .get(`/client_request/${clientRequestId}/contragent_avr/list/`)
      .then((res) => res?.data);
  },
  async create(body) {
    return await instance()
      .post(`/client_request/contragent_avr/create/`, body)
      .then((res) => res?.data);
  },
  async approve(contragentAvrId) {
    return await instance()
      .post(`/client_request/contragent_avr/approve/${contragentAvrId}/`)
      .then((res) => res?.data);
  },
  async decline(contragentAvrId) {
    return await instance()
      .post(`/client_request/contragent_avr/decline/${contragentAvrId}/`)
      .then((res) => res?.data);
  },
  async listContractorAgreementForAvrModal(clientRequestId) {
    return await instance()
      .get(
        `/client_request/${clientRequestId}/contragent_avr/contractor-agreement-for-avr-modal/list/`
      )
      .then((res) => res?.data);
  },
  async listContractorsForAvrModal(clientRequestId) {
    return await instance()
      .get(
        `/client_request/${clientRequestId}/contragent_avr/contractors-for-avr-modal/list/`
      )
      .then((res) => res?.data);
  },
  downloadDocument(contragentAvrId) {
    return `/client_request/contragent_avr/document/download/${contragentAvrId}/`;
  },
  /** company_tab через public.read_company_for_select */
  async listCompaniesForSelect() {
    return await instance()
      .get(`/common/companies/read_fs/`)
      .then((res) => res?.data);
  },
};
